/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { TableLayout } from "#layouts";
import { CustomTable } from "#components";

import ImagesUrl from "#constants/images.js";
import globalConfig from "#constants/globalConfig.js";
import useGet from "#hooks/useGet.js";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { FiledProcessData } from "#utils/helpers.js";
import { scoutingModalHeader } from "#utils/seeds.js";

const SelectSubjectList = ({
  currentPage,
  onDataCountChange,
  handlePrevPage,
  handleNextPage,
  dataCount,
  searchInput,
  expandedRow,
  toggleRow,
  setSelectedField,
  selectedFieldId,
  setSelectedFieldId,
  setSelectedSubfields,
  selectedSubfields,
  filedModal,
  seasonId,
}) => {
  const [formattedData, setFormattedData] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  console.log(seasonId, "seasonId");

  const GrowerId = JSON.parse(localStorage.getItem(globalConfig.GROWER_ID));
  const {
    data: fieldListData,
    isLoading: isFieldLoading,
    refetch: isFieldRefetch,
  } = useGet(
    ENDPOINTS.LIST_FIELD,
    [QUERY_KEYS.LIST_FIELD_QUERY_KEY, seasonId?.seasonId],
    {
      growerId: GrowerId,
      page: currentPage,
      limit: dataCount,
      search: searchInput,
      seasonId: seasonId?.seasonId,
    }
  );

  console.log(seasonId?.year, "yeartesting");

  // const handleFieldSelect = (fieldItem, index) => {
  //   if (selectedFieldId === fieldItem?._id) {
  //     setSelectedFieldId(null);
  //     setSelectedSubfields([]);
  //     setSelectedField(null);
  //   } else {
  //     toggleRow(index);
  //     setSelectedFieldId(fieldItem?._id);
  //     setSelectedSubfields(fieldItem?.subFields?.map((sf) => sf?._id));
  //     setSelectedField(fieldItem);
  //   }
  // };
  const handleFieldSelect = (fieldItem, index) => {
    const currentFieldIds = selectedFieldId || []; // Ensure it's never null
    const isSelected = currentFieldIds.includes(fieldItem?._id);

    if (isSelected) {
      setSelectedFieldId((prev) => prev.filter((id) => id !== fieldItem?._id));
      setSelectedSubfields((prev) =>
        prev.filter(
          (sfId) => !fieldItem?.subFields?.some((sf) => sf._id === sfId)
        )
      );
      setSelectedField((prev) =>
        prev.filter((field) => field._id !== fieldItem?._id)
      );
    } else {
      toggleRow(index);
      setSelectedFieldId((prev) => [...(prev || []), fieldItem?._id]); // Ensure prev is an array
      setSelectedSubfields((prev) => [
        ...(prev || []),
        ...(fieldItem?.subfield?.map((sf) => sf?._id) || []),
      ]);
      setSelectedField((prev) => [...(prev || []), fieldItem]);
    }
  };

  // const handleSubfieldSelect = (subfieldId, parentFieldId) => {
  //   const isSubfieldSelected = selectedSubfields.includes(subfieldId);
  //   const updatedSubfields = isSubfieldSelected
  //     ? selectedSubfields.filter((_id) => _id !== subfieldId)
  //     : [...selectedSubfields, subfieldId];

  //   setSelectedSubfields(updatedSubfields);

  //   if (!isSubfieldSelected) {
  //     setSelectedFieldId(parentFieldId);
  //     const parentField = formattedData.find(
  //       (field) => field._id === parentFieldId
  //     );
  //     setSelectedField(parentField);
  //   } else if (updatedSubfields.length === 0) {
  //     setSelectedFieldId(null);
  //     setSelectedField(null);
  //   } else {
  //     const parentField = formattedData.find(
  //       (field) => field._id === parentFieldId
  //     );
  //     setSelectedField({
  //       ...parentField,
  //       subFields: parentField?.subFields?.filter((sf) =>
  //         updatedSubfields.includes(sf._id)
  //       ),
  //     });
  //   }
  // };

  const handleSubfieldSelect = (subfieldId, parentFieldId) => {
    const isSubfieldSelected = selectedSubfields.includes(subfieldId);
    const updatedSubfields = isSubfieldSelected
      ? selectedSubfields.filter((_id) => _id !== subfieldId)
      : [...selectedSubfields, subfieldId];

    setSelectedSubfields(updatedSubfields);

    const parentField = formattedData.find(
      (field) => field._id === parentFieldId
    );
    const isParentSelected = selectedFieldId.includes(parentFieldId);

    if (!isSubfieldSelected) {
      // Add parent field if not already selected
      if (!isParentSelected) {
        setSelectedFieldId((prev) => [...prev, parentFieldId]);
        setSelectedField((prev) => [...prev, parentField]);
      }
    } else if (updatedSubfields.length === 0) {
      // If no subfields are selected, remove the parent field
      setSelectedFieldId((prev) => prev.filter((id) => id !== parentFieldId));
      setSelectedField((prev) =>
        prev.filter((field) => field._id !== parentFieldId)
      );
    } else {
      // Update selectedFields to only include the selected subfields
      setSelectedField((prev) =>
        prev.map((field) =>
          field._id === parentFieldId
            ? {
                ...field,
                subFields: field?.subfield?.filter((sf) =>
                  updatedSubfields.includes(sf._id)
                ),
              }
            : field
        )
      );
    }
  };
  useEffect(() => {
    if (fieldListData && fieldListData.data && fieldListData.data.list) {
      const formatted = FiledProcessData(fieldListData.data.list);
      setFormattedData(formatted);
    }
  }, [fieldListData]);
  useEffect(() => {
    isFieldRefetch();
  }, [searchInput, currentPage, dataCount, filedModal]);

  // Sorting function based on cropName
  const sortedData = formattedData.sort((a, b) => {
    const cropNameA = a.cropData[0]?.cropName || "";
    const cropNameB = b.cropData[0]?.cropName || "";
    return sortOrder === "asc"
      ? cropNameA.localeCompare(cropNameB)
      : cropNameB.localeCompare(cropNameA);
  });

  // const sortedData = formattedData.map((field) => {
  //   return {
  //     ...field,
  //     cropData: field.cropData.sort((a, b) => {
  //       return sortOrder === "asc"
  //         ? a.cropName.localeCompare(b.cropName)
  //         : b.cropName.localeCompare(a.cropName);
  //     }),
  //   };
  // });

  const handelSortData = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };
  console.log(formattedData, "formattedData");

  return (
    <div className="common-modal-form">
      <div className="modal_table">
        <TableLayout
          tableHeader={scoutingModalHeader(seasonId?.year)}
          isEmpty={sortedData?.length === 0}
          isLoading={isFieldLoading}
          currentPage={currentPage}
          totalItems={fieldListData?.data?.totalItems}
          onDataCountChange={onDataCountChange}
          handlePrevPage={handlePrevPage}
          handleNextPage={handleNextPage}
          rowLimit={dataCount}
        >
          <CustomTable
            tableHeader={scoutingModalHeader(seasonId?.year)}
            iconRequire={true}
            handelClick={handelSortData}
          >
            {sortedData?.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  <tr className="cursor-pointer position-relative" key={index}>
                    <td onClick={() => toggleRow(index)}>
                      <span className="hstack gap-3">
                        {item?.subfield?.length > 0 ? (
                          <span
                            className={`drop_icon ${
                              expandedRow === index ? "active" : ""
                            }`}
                          >
                            <img
                              onClick={() => toggleRow(index)}
                              className="drop_icon"
                              src={ImagesUrl.dopeIcon}
                              alt="drop-icon .."
                            />
                          </span>
                        ) : (
                          <span
                            className={`drop_icon ${
                              expandedRow === index ? "active" : ""
                            }`}
                          ></span>
                        )}

                        <span>{item?.name}</span>
                      </span>
                    </td>

                    <td onClick={() => toggleRow(index)}>
                      {item?.cropData?.length > 0
                        ? item.cropData.map((crop) => crop.cropName).join(", ")
                        : "-"}
                    </td>
                    <td onClick={() => toggleRow(index)}>{item?.area}</td>
                    <td className="checkbox-container">
                      <input
                        type="checkbox"
                        checked={selectedFieldId.includes(item._id)} // Check if item._id is in the array
                        id={`checkbox-${item._id}`}
                        onChange={() => handleFieldSelect(item, index)}
                      />
                      <label htmlFor={`checkbox-${item._id}`}></label>
                    </td>
                  </tr>
                  {expandedRow === index &&
                    item?.subfield?.map((subRowData, i) => {
                      return (
                        <tr
                          className={`sub-row ${
                            expandedRow === index ? "expanded" : ""
                          }`}
                          key={i}
                        >
                          <td>{subRowData?.name}</td>
                          <td>{subRowData?.cropName}</td>

                          <td>-</td>
                          <td className="checkbox-container">
                            <input
                              type="checkbox"
                              checked={selectedSubfields.includes(
                                subRowData?._id
                              )}
                              id={`subCheckbox-${index}-${i}`}
                              onChange={() =>
                                handleSubfieldSelect(
                                  subRowData?._id,
                                  item._id,
                                  item?.subfield
                                )
                              }
                            />
                            <label
                              htmlFor={`subCheckbox-${index}-${i}`}
                            ></label>
                          </td>
                        </tr>
                      );
                    })}
                </React.Fragment>
              );
            })}
          </CustomTable>
        </TableLayout>
      </div>
    </div>
  );
};

export default SelectSubjectList;
